
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!


export class GenPopover {

    id: number;
    displayText: string;
    layerId: number;
    ordering: number;
    propertyName: string;
    suffix: string;
    title: boolean;
    type: string;
    valueFormat: string;
    valuePipe: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genPopover: GenPopover);
    constructor( id: number );

    constructor( input?: GenPopover|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.displayText = input.displayText; // string [string]
            this.layerId = input.layerId; // int [number]
            this.ordering = input.ordering; // int [number]
            this.propertyName = input.propertyName; // string [string]
            this.suffix = input.suffix; // string [string]
            this.title = input.title; // boolean [boolean]
            this.type = input.type; // string [string]
            this.valueFormat = input.valueFormat; // string [string]
            this.valuePipe = input.valuePipe; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenPopover[] {
        if (arr && arr.map) {
          return arr.map(a => new GenPopover(a));
        } else {
          return [];
        }
    }
}

